/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function LiveEditsOff({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#LiveEditsOff_svg__a)"><path fillRule="evenodd" d="M1 8.6A.6.6 0 0 1 .4 8a7.6 7.6 0 0 1 1.819-4.933l-.643-.643a.6.6 0 1 1 .848-.848l12 12a.6.6 0 0 1-.848.848l-2.59-2.59-2.59 2.59a2.6 2.6 0 0 1-1.343.713l-3.348.65a.6.6 0 0 1-.703-.704l.65-3.347a2.6 2.6 0 0 1 .713-1.343l2.59-2.59-1.746-1.745A3.4 3.4 0 0 0 4.6 8a.6.6 0 0 1-1.2 0 4.6 4.6 0 0 1 .95-2.8L3.07 3.918A6.4 6.4 0 0 0 1.6 8a.6.6 0 0 1-.6.6Zm6.803.052-2.126 2.126 2.333 2.334 2.127-2.127-2.334-2.333Zm-2.896 3.053 2.177 2.177c-.084.034-.17.06-.26.077l-2.475.48.48-2.475c.018-.089.044-.176.078-.26Z" clipRule="evenodd" /><path d="M4.103 2.154a.6.6 0 0 1 .237-.814A7.599 7.599 0 0 1 8 .4a.6.6 0 0 1 0 1.2 6.4 6.4 0 0 0-3.083.791.6.6 0 0 1-.814-.237ZM6.046 4.459a.6.6 0 0 1 .353-.772A4.6 4.6 0 0 1 8 3.4a.6.6 0 0 1 0 1.2 3.4 3.4 0 0 0-1.183.212.6.6 0 0 1-.771-.353ZM14.445 3.99a2.6 2.6 0 0 0-3.677 0L9.182 5.576a.6.6 0 0 0 .849.848l1.586-1.586a1.4 1.4 0 0 1 1.98 0l.353.354a1.4 1.4 0 0 1 0 1.98l-1.624 1.624a.6.6 0 0 0 .848.849L14.8 8.02a2.6 2.6 0 0 0 0-3.676l-.354-.354Z" /></g><defs><clipPath id="LiveEditsOff_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;